/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const Beaker: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M15.75 4.50171C16.4417 4.50171 17 3.94254 17 3.25171C17 2.56171 16.4417 2.00171 15.75 2.00171C15.0583 2.00171 14.5 2.56171 14.5 3.25171C14.5 3.94254 15.0583 4.50171 15.75 4.50171ZM12 5.75254C12.69 5.75254 13.25 5.19254 13.25 4.50088C13.25 3.81088 12.6917 3.25088 12 3.25088C11.3083 3.25088 10.75 3.81088 10.75 4.50088C10.75 5.19171 11.31 5.75254 12 5.75254ZM19.2208 20.7625C17.9658 18.3475 15.75 13.2509 15.75 13.2509V8.25088H16.375C16.7192 8.25088 17 7.97088 17 7.62588C17 7.28171 16.7192 7.00088 16.375 7.00088H8.875C8.53 7.00088 8.25 7.28171 8.25 7.62588C8.25 7.97088 8.53 8.25088 8.875 8.25088H9.5V13.2509C9.5 13.2509 7.3325 18.5267 6.10667 20.8842C5.52667 22.0017 5.52667 22.0017 6.91 22.0017C9.9275 22.0017 15.8092 22.0017 18.6575 22.0017C19.2167 22.0017 19.8667 22.0017 19.2217 20.7617L19.2208 20.7625ZM10.75 13.2517V8.25171H14.5V13.2517C14.5 13.2517 14.72 13.7675 15.035 14.5017H10.2425C10.5425 13.7692 10.75 13.2517 10.75 13.2517ZM16.9225 20.7517C14.55 20.7517 11.1067 20.7517 8.59167 20.7517C7.43917 20.7517 7.43917 20.7517 7.9225 19.795C8.435 18.78 9.145 17.1375 9.725 15.7517H15.58C16.1692 17.09 16.8792 18.6692 17.3942 19.6875C17.93 20.7509 17.3892 20.7509 16.9225 20.7509V20.7517Z" />

    </StyledIconBase>
  )
})

Beaker.displayName = 'Beaker'

export const BeakerDimensions = {height: 24, width: 24}
